import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

// DON NOT REMOVE the comments around 'import style.scss'
// ###STYLE_REPLACEMENT_START###
import './style.scss'
// ###STYLE_REPLACEMENT_END###

const ContentLabel = ({ value, translation, extraClasses }) => {
  const translationObj = _(translation)
    .entries()
    .map(([key, intlId]) => {
      return [key, <FormattedMessage key={intlId} id={intlId} />]
    })
    .fromPairs()
    .value()

  return (
    <span className={classnames('gdpp-component text-grey', extraClasses)}>
      <FormattedMessage id={value} defaultMessage={value} values={translationObj} />
    </span>
  )
}

ContentLabel.propTypes = {
  value: PropTypes.string.isRequired,
  translation: PropTypes.object,
  extraClasses: PropTypes.string
}

ContentLabel.defaultProps = {
  translation: {},
  extraClasses: ''
}

export default ContentLabel
